import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ScrollText } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/pas-admin/act-log`;

// Audit trail of everything the admin did inside subscriber accounts
export const AdminActLog = ({ token }) => {
  const [log, setLog] = useState(null);
  useEffect(() => {
    axios.get(API, { headers: { Authorization: `Bearer ${token}` } }).then(r => setLog(r.data.log)).catch(() => setLog([]));
  }, [token]);
  if (!log) return null;
  return (
    <div className="bg-slate-800 border border-slate-700 rounded-xl p-5 mt-6" data-testid="admin-act-log">
      <h3 className="text-white font-semibold flex items-center gap-2 mb-2"><ScrollText className="w-5 h-5 text-red-400" /> Admin access log</h3>
      {!log.length ? <p className="text-sm text-slate-500" data-testid="admin-act-log-empty">You haven't opened any subscriber account yet.</p> : (
        <div className="overflow-x-auto max-h-72 overflow-y-auto"><table className="w-full text-xs text-slate-300">
          <thead className="sticky top-0 bg-slate-800"><tr className="text-left text-slate-500"><th className="py-1">When</th><th>Admin</th><th>Subscriber</th><th>Action</th></tr></thead>
          <tbody>{log.map((l, i) => (
            <tr key={`${l.act_id}-${i}`} className="border-t border-slate-700" data-testid={`admin-act-log-row-${i}`}>
              <td className="py-1">{new Date(l.at).toLocaleString()}</td><td>{l.admin_email}</td><td>{l.client_email}</td>
              <td className="font-mono">{l.method === 'OPEN' ? 'Opened account' : `${l.method} ${l.path.replace('/api/', '')}`}</td>
            </tr>
          ))}</tbody>
        </table></div>
      )}
    </div>
  );
};
